import findIndex from 'lodash/findIndex';
import { produce } from "immer";
import {
    CUSTOMER_REPLY_TO_QUERY,
    SHOW_QUERY_REPLAY,
    HIDE_QUERY_REPLAY,
    SET_QUERY_GRID_DATA_SOURCE,
    CUSTOMER_REOPEN_QUERY_SUCCESS
} from './constants';

import { ORDER_DETAILS_RAISE_QUERY, ORDER_DETAILS_RAISE_QUERY_CANCELLED, ORDER_DETAILS_SUBMIT_RAISE_QUERY_SUCCESS } from '../OrderDetails/constants';
import { createQueryDetailsReducer } from './queryDetailsReducer';
import { combineReducers } from 'redux';

const initialState = {
    items: []
}

export function createQueryReducer(gridName) {

    return function queryGridReducer(state = initialState, action) {
        if (gridName != action.gridName) {
            return state;
        }
        
        var newList = state.items || [];
        return produce(state, (draft) => {
            switch (action.type) {
                case SET_QUERY_GRID_DATA_SOURCE:
                    draft.items = action.queryList.queries;
                    draft.totalQueriesCount = action.queryList.queriesCount;
                    break;

                case ORDER_DETAILS_RAISE_QUERY:
                    var newQuery = {
                        rowTemplateKey: action.rowTemplateKey,
                        data: { /*<<<data context for template*/
                            queryId: -1,
                            orderId: action.orderId,
                            queryDetails: []
                        }/*action.data*/
                    };
                    draft.items.splice(0, 0, newQuery);
                    break;

                // Results for a query that is no longer listed (e.g. a reply that completes after the user opened
                // another order, which re-initialised the grid) are ignored rather than applied to row 0.
                case SHOW_QUERY_REPLAY:
                    var rowIndex = findIndex(newList, { 'queryId': action.queryId });
                    if (rowIndex < 0) break;
                    draft.items.splice(rowIndex + 1, 0, { rowTemplateKey: action.rowTemplateKey, data: action.data }/*<<<data context for template*/);
                    break;
                
                case CUSTOMER_REOPEN_QUERY_SUCCESS:
                    var rowIndex = findIndex(newList, { 'queryId': action.queryId });
                    // next row should be open query template (unless the user has collapsed it meanwhile)
                    if (rowIndex < 0 || !isDetailsRow(newList[rowIndex + 1])) break;
                    draft.items[rowIndex+ 1].data.status="Reopen"/*<<<data context for template*/;
                    break;

                case CUSTOMER_REPLY_TO_QUERY:
                    var rowIndex1 = findIndex(newList, { 'queryId': action.queryDto.queryId });
                    if (rowIndex1 < 0) break;
                    draft.items[rowIndex1].needCustomerReply = false; // reset flag
                    break;

                case HIDE_QUERY_REPLAY:
                    var rowIndex2 = findIndex(newList, { 'queryId': action.queryId });
                    if (rowIndex2 < 0 || !isDetailsRow(newList[rowIndex2 + 1])) break;
                    draft.items.splice(rowIndex2 + 1, 1);
                    break;

                case ORDER_DETAILS_RAISE_QUERY_CANCELLED:
                    // the new-query row is always first (see ORDER_DETAILS_RAISE_QUERY), unless the grid was
                    // reloaded meanwhile
                    if (isNewQueryRow(newList[0])) draft.items.splice(0, 1);
                    break;

                case ORDER_DETAILS_SUBMIT_RAISE_QUERY_SUCCESS:
                    // remove details row
                    if (isNewQueryRow(newList[0])) draft.items.splice(0, 1);

                    // add new query data, unless a reload of the grid meanwhile already lists it
                    if (findIndex(newList, { 'queryId': action.queryDto.queryId }) < 0) draft.items.splice(0, 0, action.queryDto);
                    break;
            }
        });
    }
}

// Details rows (an expanded query, or a new query being raised) are template rows; query rows are not.
function isDetailsRow(row) {
    return row != undefined && row.rowTemplateKey != undefined;
}

function isNewQueryRow(row) {
    return isDetailsRow(row) && row.data != undefined && row.data.queryId === -1;
}

export function create(gridName) {
    var red = {
        dataSource: createQueryReducer(gridName),
        ui: createQueryDetailsReducer(gridName)
        //ui:queryDetailsReducer
    };
    const grid = combineReducers(red);
    return function queryGrid(state, action) {
        // Query details that arrive after the grid was reloaded (which drops every row's details state) are
        // ignored by both halves; adding the details row alone would leave it without state to render.
        if (state && action.type === SHOW_QUERY_REPLAY && action.gridName == gridName
            && state.ui.queryGridNavigationColumnState[action.queryId] == undefined) {
            return state;
        }
        return grid(state, action);
    };
}
